import { Map } from 'immutable'
import _ from 'lodash'

import {
    GOOGLE_MAP_INIT,
    GOOGLE_MAP_CLOSE,
    GOOGLE_MAP_ZOOM_CHANGE,
    GOOGLE_MAP_CHANGE_URL,
    GOOGLE_MAP_CHECKBOX_CHANGE,
    GOOGLE_MAP_CHANGE_SATELLITE_VIEW,
    GOOGLE_MAP_CHANGE_STREETVIEW_URL,
    GOOGLE_MAP_TOGGLE_STREETVIEW_EXPAND,
    GOOGLE_MAP_TOGGLE_COLLAPSED,
} from './constants'

import { getGoogleMapsStaticUrl, getStreetViewUrl } from './helpers'

export default function googleMapReducer(state = new Map(), action = {}) {
    switch (action.type) {
        case GOOGLE_MAP_INIT: {
            const id = _.get(action, 'data.id', null)
            const addresses = _.get(action, 'data.addresses', null)
            const activeAddress = _.get(action, 'data.activeAddress', null)
            const activeAddressZoom = _.get(action, 'data.activeAddressZoom', null)
            const showRegistered = _.get(action, 'data.showRegistered', null)
            const showBranch = _.get(action, 'data.showBranch', null)
            const showShops = _.get(action, 'data.showShops', null)

            if (!id) return state

            const mapUrl = getGoogleMapsStaticUrl(
                addresses,
                activeAddress,
                activeAddressZoom,
                showRegistered,
                showBranch,
                showShops
            )
            const streetViewUrl = getStreetViewUrl(activeAddress)

            return state.set(id, {
                mapUrl,
                streetViewUrl,
                activeAddressZoom: false,
                collapsed: false,
                streetViewExpanded: false,
                showRegistered: true,
                showBranch: true,
                showShops: true,
                satelliteView: false,
            })
        }
        case GOOGLE_MAP_CLOSE: {
            const id = _.get(action, 'data.id', null)

            if (!id) return state

            return state.remove(id)
        }
        case GOOGLE_MAP_ZOOM_CHANGE: {
            const id = _.get(action, 'data.id', null)
            const activeAddressZoom = _.get(action, 'data.activeAddressZoom', null)

            if (!id) return state

            return state.setIn([id, 'activeAddressZoom'], activeAddressZoom)
        }
        case GOOGLE_MAP_CHANGE_URL: {
            const id = _.get(action, 'data.id', null)
            const addresses = _.get(action, 'data.addresses', null)
            const activeAddress = _.get(action, 'data.activeAddress', null)
            const activeAddressZoom = _.get(action, 'data.activeAddressZoom', null)
            const showRegistered = _.get(action, 'data.showRegistered', null)
            const showBranch = _.get(action, 'data.showBranch', null)
            const showShops = _.get(action, 'data.showShops', null)
            const satelliteView = _.get(action, 'data.satelliteView', null)

            if (!id) return state

            const mapUrl = getGoogleMapsStaticUrl(
                addresses,
                activeAddress,
                activeAddressZoom,
                showRegistered,
                showBranch,
                showShops,
                satelliteView
            )

            return state.setIn([id, 'mapUrl'], mapUrl)
        }
        case GOOGLE_MAP_CHANGE_SATELLITE_VIEW: {
            const id = _.get(action, 'data.id', null)

            if (!id) return state

            const value = state.getIn([id, 'satelliteView'], false)

            return state.setIn([id, 'satelliteView'], !value)
        }
        case GOOGLE_MAP_CHECKBOX_CHANGE: {
            const id = _.get(action, 'data.id', null)
            const checkBoxName = _.get(action, 'data.checkBoxName', null)
            const checked = _.get(action, 'data.checked', true)

            if (!id || !checkBoxName) return state

            return state.setIn([id, checkBoxName], checked)
        }
        case GOOGLE_MAP_CHANGE_STREETVIEW_URL: {
            const id = _.get(action, 'data.id', null)
            const activeAddress = _.get(action, 'data.activeAddress', null)

            if (!id) return state

            const streetViewUrl = getStreetViewUrl(activeAddress)

            return state.setIn([id, 'streetViewUrl'], streetViewUrl)
        }
        case GOOGLE_MAP_TOGGLE_STREETVIEW_EXPAND: {
            const id = _.get(action, 'data.id', null)
            const value = _.get(action, 'data.value', null)

            if (!id) return state

            return state.setIn([id, 'streetViewExpanded'], value)
        }
        case GOOGLE_MAP_TOGGLE_COLLAPSED: {
            const id = _.get(action, 'data.id', null)
            const value = _.get(action, 'data.value', null)

            if (!id) return state

            return state.setIn([id, 'collapsed'], value)
        }
        default:
            return state
    }
}
